import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import qs from 'qs'

const vm = new Vue()

const oAuthRequest = axios.create({
  baseURL: process.env.VUE_APP_SAN_API_BASEURL,
  timeout: 10000
})

const appRequest = axios.create({
  baseURL: process.env.VUE_APP_SAN_API_BASEURL,
  timeout: 10000
})

appRequest.interceptors.request.use(function (config) {
  let accessToken = store.state.authorization.app
  config.headers = { 'Authorization': accessToken.token_type + ' ' + accessToken.access_token }
  return config
})

const userRequest = axios.create({
  baseURL: process.env.VUE_APP_SAN_API_BASEURL,
  timeout: 10000
})

userRequest.interceptors.request.use(function (config) {
  let accessToken = store.state.authorization.user
  config.headers = { 'Authorization': accessToken.token_type + ' ' + accessToken.access_token }
  return config
})

export default {
  userRequest (options) {
    return new Promise((resolve, reject) => {
      if (options) {
        if (options.url && !options.url.includes('language')) {
          if (options.url.includes('?')) {
            options.url = `${options.url}&language=${vm.$ml.current}`
          } else {
            options.url = `${options.url}?language=${vm.$ml.current}`
          }
        }
      }

      userRequest(options).then(response => {
        let result = response.data
        result.response = response
        return resolve(result)
      }).catch(e => {
        if (e.response && e.response.data && e.response.data.exception && e.response.data.exception.message) {
          if (e.response.data.exception.hasOwnProperty('details')) {
            Object.keys(e.response.data.exception.details).map(function (key) {
              let value = e.response.data.exception.details[key][0]
              e.response.data.exception.message += '<p>' + value + '</p>'
            })
          }

          return reject(e.response.data.exception)
        } else {
          return reject(e.message)
        }
      })
    })
  },

  appRequest (options) {
    let api = this
    return new Promise((resolve, reject) => {
      if (options) {
        if (options.url) {
          if (options.url && !options.url.includes('language')) {
            if (options.url.includes('?')) {
              options.url = `${options.url}&language=${vm.$ml.current}`
            } else {
              options.url = `${options.url}?language=${vm.$ml.current}`
            }
          }
        }
      }

      appRequest(options).then(response => {
        let result = response.data
        result.response = response
        return resolve(result)
      }).catch(e => {
        if (e.response && e.response.status == 400) {
          api.requestAppAccessToken().then(r => {
            store.commit('setAuthorizationApp', r)
          })
          
          if (e.response.data && e.response.data.error_description) {
            return reject(new Error(e.response.data.error_description))
          } else {
            return reject(e)
          }
        }

        if (e.response && e.response.data && e.response.data.exception && e.response.data.exception.message) {
          if (e.response.data.exception.hasOwnProperty('details')) {
            Object.keys(e.response.data.exception.details).map(function (key) {
              let value = e.response.data.exception.details[key][0]
              e.response.data.exception.message += '<p>' + value + '</p>'
            })
          }

          return reject(e.response.data.exception)
        } else {
          return reject(e.message)
        }
      })
    })
  },

  authenticateUser (username, password) {
    let api = this
    return new Promise((resolve, reject) => {
      api.requestUserAccessToken({username: username, password: password}).then(() => {
        api
          .userRequest({
            url: `/user/me/info?language=${vm.$ml.current}`,
            method: 'get'
          })
          .then(data => resolve(data.user))
          .catch(e => reject(e))
      }).catch(e => reject(e))
    })
  },

  authenticateUserByFingerprint (username, fingerprint) {
    let api = this
    return new Promise((resolve, reject) => {
      api.requestUserAccessToken({username: username, fingerprint: fingerprint, password: 'fingerprint'}).then(() => {
        api
          .userRequest({
            url: `/user/me/info?language=${vm.$ml.current}`,
            method: 'get'
          })
          .then(data => resolve(data.user))
          .catch(e => reject(e))
      }).catch(e => reject(e))
    })
  },

  requestUserAccessToken (data) {
    const credential = store.state.credential.user
    return new Promise((resolve, reject) => {
      oAuthRequest.request({
        url: `/oauth2/token?language=${vm.$ml.current}`,
        method: 'post',
        data: qs.stringify({
          ...data,
          grant_type: 'frequenter',
          client_id: credential.client_id,
          client_secret: credential.client_secret,
          scope: 'me_info,me_update,me_store_rfid,place_booking,booking_transfer,me_dependents,me_dependents_store,me_dependents_destroy'
        })
      }).then(response => {
        store.commit('setAuthorizationUser', response.data)
        resolve(response.data)
      }).catch(e => {
        if (e.response && e.response.status == 400) {
          if (e.response.data && e.response.data.error_description) {
            return reject(new Error(e.response.data.error_description))
          } else {
            return reject(e)
          }
        }
        
        if (e.response && e.response.data && e.response.data.exception && e.response.data.exception.message) {
          return reject(e.response.data.exception)
        } else {
          return reject(e.message)
        }
      })
    })
  },

  requestAppAccessToken () {
    const credential = store.state.credential.app
    return new Promise((resolve, reject) => {
      oAuthRequest.request({
        url: `/oauth2/token?language=${vm.$ml.current}`,
        method: 'post',
        data: qs.stringify({
          grant_type: 'client_credentials',
          client_id: credential.client_id,
          client_secret: credential.client_secret,
          scope: 'user_new,country_all,federative_unit_all,city_all,neighborhood_all,educational_institution_types,unit_places,user_update_password,user_recovery_login,equipment_info,special_needs_all,educational_stage'
        })
      }).then(response => {
        resolve(response.data)
      }).catch(e => {
        if (e.response && e.response.data && e.response.data.exception && e.response.data.exception.message) {
          return reject(e.response.data.exception)
        } else {
          return reject(e.message)
        }
      })
    })
  },

  renewAppAccessToken () {
    return new Promise((resolve, reject) => {
      if (store.state.authorization.app) {
        resolve()
      } else {
        reject()
      }
    })
  }

}
